import styled from "styled-components";

export const TravelInfoWrapper = styled.div`
  width: 100%;
  height: auto;
`;
